<div class="full-page-container">
  <div class="d-none d-lg-block">
    <fgb-banner [title]="name$ | async"></fgb-banner>
  </div>

  <fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="'/'"></fgb-page-header>

  <fgb-account-nav></fgb-account-nav>

  <div class="container">
    <div class="row">
      <div class="col-lg-6 d-none d-lg-block">
        <h4 class="font-size-18 text-uppercase section-title">{{ 'account.member.card.title' | translate }}</h4>
        <fgb-member-card></fgb-member-card>
      </div>
      <div class="col-12 col-lg-6">
        <h4 class="font-size-18 text-uppercase section-title">{{ 'account.details.title' | translate }}</h4>
        <fgb-account-details></fgb-account-details>
      </div>
    </div>
  </div>
</div>
